import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const SalesByProductReport: React.FC = () => (
  <ReportPageShell
    reportType="sales-by-product"
    title="Sales by Product"
    subtitle="Same metrics as Sales by Product Group but at the SKU level, with the group as an attribute. SKU and product name snapshot from sale time."
    maxRangeDays={366}
    bullets={[
      'SKU',
      'Product Name',
      'Product Group',
      'Quantity (net of line refunds)',
      'Net',
      'Tax',
      'Gross',
      'Discounts',
    ]}
  />
);

export default SalesByProductReport;
